export const ADVERTISEMENT_CONSTS = {
    GET_ADVERTISEMENTS: "GET_ADVERTISEMENTS",
    DELETE_ADVERTISEMENT_BY_ID: "DELETE_ADVERTISEMENT_BY_ID",
};
